import {axios} from "../../../axiosConfig";

const url = "api/admin/v1/user/check";

export const apiCheckUser = (bc, callback, error) => {
    axios.get(url + "/" + bc)
        .then(response => callback(response.data.data))
        .catch(err => error(err))
}
